var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarageIcon0101(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st44{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bellboy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M256,272c-33.1,0-60-26.9-60-60c0-11,9-20,20-20s20,9,20,20c0,11,9,20,20,20c11,0,20-9,20-20c0-11,9-20,20-20 s20,9,20,20C316,245.1,289.1,272,256,272z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M296,0h-80c-55.1,0-100,44.9-100,100v112c0,77.2,62.8,140,140,140s140-62.8,140-140V100 C396,44.9,351.1,0,296,0z M356,212c0,55.1-44.9,100-100,100s-100-44.9-100-100v-60h140c11,0,20-9,20-20s-9-20-20-20H156v-12 c0-33.1,26.9-60,60-60h80c33.1,0,60,26.9,60,60V212z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M452,512H60c-33.1,0-60-26.9-60-60c0-30.5,9.6-59.4,27.8-83.8c17.6-23.5,42.6-41.2,70.5-49.9 c10.5-3.3,21.8,2.6,25,13.2c3.3,10.5-2.6,21.8-13.2,25C68.2,369.6,40,407.9,40,452c0,11,9,20,20,20h392c11,0,20-9,20-20 c0-44.1-28.2-82.4-70.2-95.5c-10.5-3.3-16.4-14.5-13.2-25c3.3-10.5,14.5-16.4,25-13.2c27.9,8.7,53,26.4,70.5,49.9 c18.2,24.3,27.8,53.3,27.8,83.8C512,485.1,485.1,512,452,512L452,512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M372,432h-40c-11,0-20-9-20-20s9-20,20-20h40c11,0,20,9,20,20S383,432,372,432z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageIcon0101);
export default __webpack_public_path__ + "static/media/garage-icon-01-01.70808185768fa742b88fb51822852b2b.svg";
export { ForwardRef as ReactComponent };